module.exports = __webpack_public_path__ + "img/yajun.1ec2fc8f.png";